<template>
    <div class="TicketCreatePage">
        <DashboardSectionHeader title="Add Ticket">
            <Button to="/company/tickets" class="link primary">Cancel</Button>
            <Button class="primary" @click="handleCreate" :disabled="submitPending">Create</Button>
        </DashboardSectionHeader>

        <TicketForm ref="ticketForm" v-bind.sync="ticket"/>

        <DashboardSectionHeader>
            <Button to="/company/tickets" class="link primary">Cancel</Button>
            <Button class="primary" @click="handleCreate" :disabled="submitPending">Create</Button>
        </DashboardSectionHeader>
    </div>
</template>

<script>
import * as api from '@/api';
import DashboardSectionHeader from '@/components/DashboardSectionHeader';
import DashboardEditSection from '@/components/DashboardEditSection';
import TicketForm from './components/TicketForm';

export default {
    name: 'TicketCreatePage',

    components: {
        DashboardSectionHeader,
        DashboardEditSection,
        TicketForm,
    },

    data: () => ({
        ticket: {
            submittedAt: null,
            project: null,
            user: null,
            truck: null,
            trailer: null,
            odometerPrecheck: null,
            precheckStartAt: null,
            loads: [],
            yardLeaveAt: null,
            yardArriveAt: null,
            postcheckEndAt: null,
            odometerPostcheck: null,
            notes: null,
        },

        submitPending: false,
        submitError: null,
    }),

    methods: {
        async handleCreate() {
            if (!this.$refs.ticketForm.validate()) {
                return;
            }

            this.submitPending = true;

            const company = this.$store.state.company.id;
            this.ticket.submittedAt = new Date().toISOString();
            const res = await api.createTicket({ ...this.ticket, company });
            this.submitPending = false;

            if (res.error) {
                this.submitError = res.error.message;
                return this.$awn.alert('Failed to create ticket');
            }

            this.submitError = null;
            this.$router.push(`/company/tickets`);
        },
    },
}
</script>
